/** The title menu (docs/spec/04 §6): what is on it, where each item goes, a line about each. Pure. */

import type { MenuItem } from '../kit/menuModel';
import type { Route } from '../scene';

export interface TitleItem extends MenuItem {
  readonly route: Route;
  /** Start it in place of the title (a game) rather than open it on top. */
  readonly replace?: boolean;
  /** One line under the menu while the item is selected. */
  readonly about: string;
}

export const TITLE_ITEMS: readonly TitleItem[] = [
  {
    id: 'supernova', label: 'SUPERNOVA', about: 'THE SUCCESSOR: NEW POWERS',
    route: { to: 'play', request: { mode: 'supernova' } }, replace: true,
  },
  {
    id: 'classic', label: 'CLASSIC 1981', about: 'AS IT PLAYED IN 1981',
    route: { to: 'play', request: { mode: 'classic' } }, replace: true,
  },
  { id: 'daily', label: 'DAILY RUN', about: "TODAY'S RUN, SAME FOR ALL", route: { to: 'daily' } },
  { id: 'hiscores', label: 'HIGH SCORES', about: 'THE TEN BEST OF EACH MODE', route: { to: 'hiscores' } },
  { id: 'options', label: 'OPTIONS', about: 'LOOK, SOUND AND CONTROLS', route: { to: 'options' } },
  { id: 'help', label: 'HOW TO PLAY', about: 'THE HIVE, AND HOW TO WIN', route: { to: 'help' } },
  { id: 'credits', label: 'CREDITS', about: 'WHO, AND A TRIBUTE', route: { to: 'credits' } },
];

/** Idle this long on the title and the attract demo plays (04 §6). */
export const IDLE_MS = 20_000;

/** Where the idle title goes: the bot at the stick. */
export const DEMO_ROUTE: Route = { to: 'play', request: { mode: 'demo' } };

/** The footer's version: `V0.1.0`, whatever case or prefix the build gave it. */
export function versionLabel(version: string): string {
  return `V${version.replace(/^v/i, '')}`.toUpperCase();
}

/** The hive on parade under the logo: who flies where, mirrored about the middle. */
export const PARADE = ['stinger', 'moth', 'monarch', 'monarch', 'moth', 'stinger'] as const;

/** The x of parade member `i` at `ms`: 24 apart about the centre, swaying together as the formation does. */
export function paradeX(i: number, ms: number, cx: number): number {
  const sway = Math.round(Math.sin(ms / 900) * 10);
  return cx + (i - (PARADE.length - 1) / 2) * 24 + sway;
}
